const getLink = (path: string) => (!path.indexOf("/") ? path : `/${path}`);

export default getLink;
